/*
 * Ordine minimo.
 * Il carrello e il cassetto si aggiornano via ajax, quindi il blocco scritto in
 * liquid resterebbe fermo al valore che aveva al caricamento della pagina.
 * Qui si riascolta theme:cart:change, che porta il carrello aggiornato, e si
 * rimettono a posto tasto di pagamento, messaggio e cifra che manca.
 */
(function () {
  var selectors = {
    message: '[data-minimum-order]',
    missing: '[data-minimum-order-missing]',
    button: '[data-minimum-order-button]'
  };

  var classes = {
    hidden: 'is-hidden'
  };

  var placeholder = /\{\{\s*(\w+)\s*\}\}/;

  function withDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) {
      return '0';
    }

    var parts = (cents / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);

    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var match = format.match(placeholder);

    if (!match) {
      return format;
    }

    var value;

    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }

    var money = format.replace(placeholder, value);
    var withCode = window.theme && window.theme.settings && window.theme.settings.currency_code_enable;

    if (withCode && window.theme.currencyCode) {
      money = money + ' ' + window.theme.currencyCode;
    }

    return money;
  }

  function render(totalPrice) {
    var messages = document.querySelectorAll(selectors.message);

    if (!messages.length) {
      return;
    }

    var minimum = parseInt(messages[0].getAttribute('data-minimum-order'), 10);

    if (!minimum) {
      return;
    }

    var below = totalPrice < minimum;
    var missing = below ? minimum - totalPrice : 0;

    for (var i = 0; i < messages.length; i++) {
      messages[i].classList.toggle(classes.hidden, !below);

      var amount = messages[i].querySelector(selectors.missing);

      if (amount) {
        amount.textContent = formatMoney(missing);
      }
    }

    var buttons = document.querySelectorAll(selectors.button);

    for (var j = 0; j < buttons.length; j++) {
      buttons[j].disabled = below;
    }
  }

  document.addEventListener('theme:cart:change', function (event) {
    if (event.detail && event.detail.cart) {
      render(event.detail.cart.total_price);
    }
  });

  /*
   * Il cassetto nasce vuoto e si riempie via ajax dopo il primo evento, ma sulla
   * pagina del carrello il totale e' gia' nel markup: si legge da li' per non
   * aspettare una chiamata che potrebbe non arrivare.
   */
  function init() {
    var subtotal = document.querySelector('[data-cart-subtotal]');

    if (!subtotal) {
      return;
    }

    fetch(window.theme && window.theme.routes ? window.theme.routes.cart + '.js' : '/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        render(cart.total_price);
      })
      .catch(function (error) {
        console.warn('[ordine minimo] carrello non letto:', error && error.message);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
